import { Link } from "react-router-dom";

const PelsFishing = "/Images/Pelss.png";

const PelsFishingOwl = () => {
  return (
    <>
      {/* ── HERO ── */}
      <section
        style={{
          height: "100vh",
          position: "relative",
          backgroundImage: `url(${PelsFishing})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,.12), rgba(0,0,0,.48))",
          }}
        />

        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "0 48px",
          }}
        >
          <div style={{ maxWidth: "680px", color: "#fff", marginTop: "64px" }}>

            {/* breadcrumb + badge */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <span
                style={{
                  fontSize: "12px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "1px",
                  cursor: "pointer",
                }}
              >
                ← All Species
              </span>
              <span
                style={{
                  background: "#dc3545",
                  color: "#fff",
                  fontSize: "9px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  padding: "4px 10px",
                }}
              >
                ENDANGERED
              </span>
            </div>

            {/* heading */}
            <h1
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontSize: "clamp(3.5rem, 7vw, 5.2rem)",
                fontWeight: 400,
                lineHeight: 0.92,
                margin: "0 0 20px 0",
                letterSpacing: "-0.5px",
              }}
            >
              Pel's Fishing Owl
            </h1>

            {/* scientific name */}
            <p
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontStyle: "italic",
                fontSize: "17px",
                color: "rgba(255,255,255,.85)",
                margin: "0 0 20px 0",
              }}
            >
              Scotopelia peli · Riparian forests along rivers · Sub-Saharan Africa
            </p>

            <hr
              style={{
                borderColor: "rgba(255,255,255,.5)",
                margin: "0 0 24px 0",
                width: "520px",
                maxWidth: "100%",
              }}
            />

            {/* stats row */}
            <div style={{ display: "flex", gap: "48px" }}>
              {[
                { value: "70–100", label: "LEFT IN SOUTH AFRICA" },
                { value: "Endangered", label: "SOUTH AFRICAN RED LIST" },
                { value: "Every 2 yrs", label: "BREEDING CYCLE" },
              ].map((stat, i) => (
                <div key={i}>
                  <div
                    style={{
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "clamp(1.8rem, 3vw, 2.8rem)",
                      fontWeight: 400,
                      lineHeight: 1,
                      marginBottom: "6px",
                    }}
                  >
                    {stat.value}
                  </div>
                  <div
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "9px",
                      fontWeight: 600,
                      letterSpacing: "1.2px",
                      color: "rgba(255,255,255,.8)",
                      maxWidth: "120px",
                      lineHeight: 1.5,
                    }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* ── BODY ── */}
      <section style={{ background: "#f5f3ee", padding: "64px 0" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 24px" }}>
          <div style={{ display: "flex", gap: "48px" }}>

            {/* ── LEFT SIDEBAR ── */}
            <div style={{ width: "240px", flexShrink: 0 }}>

              {/* donate card */}
              <div
                style={{
                  background: "#ece9e2",
                  padding: "20px",
                  marginBottom: "24px",
                }}
              >
                <h6
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontSize: "15px",
                    fontWeight: 400,
                    margin: "0 0 8px 0",
                  }}
                >
                  Support This Work
                </h6>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    lineHeight: 1.7,
                    margin: "0 0 16px 0",
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  }}
                >
                  Field research, community programs, and habitat protection all depend on donations.
                </p>
                <Link to="/donate" style={{ textDecoration: "none" }}>
                  <button
                    style={{
                      width: "100%",
                      background: "#6d735d",
                      color: "#fff",
                      border: "none",
                      padding: "10px",
                      fontSize: "11px",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontWeight: 700,
                      letterSpacing: "1.5px",
                      cursor: "pointer",
                    }}
                  >
                    DONATE
                  </button>
                </Link>
              </div>

              {/* related articles */}
              <div
                style={{
                  fontSize: "10px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "2px",
                  color: "#999",
                  textTransform: "uppercase",
                  marginBottom: "4px",
                }}
              >
                Related Articles
              </div>

              {[
                { to: "/african-penguin", label: "African Penguin →", status: "Critically Endangered" },
                { to: "/pels-fishing-owl", label: "Pel's Fishing Owl →", status: "Endangered" },
                { to: "/bearded-vulture", label: "Bearded Vulture →", status: "Nearly Threatened" },
              ].map((item, i) => (
                <div key={i} style={{ borderTop: "1px solid #ddd", padding: "12px 0" }}>
                  <Link
                    to={item.to}
                    style={{
                      textDecoration: "none",
                      color: "#222",
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "14px",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    {item.label}
                  </Link>
                  <small
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "11px",
                      color: "#888",
                    }}
                  >
                    {item.status}
                  </small>
                </div>
              ))}
            </div>

            {/* ── MAIN CONTENT ── */}
            <div style={{ flex: 1, minWidth: 0 }}>

              {/* intro + quick stats */}
              <div style={{ display: "flex", gap: "40px", marginBottom: "40px", alignItems: "flex-start" }}>
                <div style={{ flex: "0 0 55%" }}>
                  <p
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13.5px",
                      lineHeight: 2,
                      color: "#555",
                      margin: 0,
                    }}
                  >
                    far more often than it is ever seen. Globally it remains rare; in South Africa, where it
was already at the edge of its range, as few as 70 individuals may remain. It is a
living indicator of river ecosystem health  and right now, the rivers are struggling.
                  </p>
                </div>

                <div style={{ flex: 1, display: "flex", gap: "0", justifyContent: "space-around", textAlign: "center" }}>
                  {[
                    { value: "2.1 kg", label: "Average Weight" },
                    { value: "63 cm", label: "Average Height" },
                    { value: "Unknown", label: "Average Lifespan" },
                  ].map((s, i) => (
                    <div key={i} style={{ padding: "0 8px" }}>
                      <div
                       style={{
          fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "17px",
          fontWeight: 600,
          marginBottom: "4px",
          lineHeight: 1.3,
        }}
                      >
                        {s.value}
                      </div>
                      <div
                        style={{
                           fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "14px",
                          color: "#888",
                        }}
                      >
                        {s.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* personal note */}
              <div
                style={{
                  background: "#fff",
                  borderLeft: "3px solid #e0a320",
                  padding: "20px 24px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "1.5px",
                    color: "#c98d2c",
                    textTransform: "uppercase",
                    marginBottom: "12px",
                  }}
                >
                  A Personal Note
                </div>
                <p
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontStyle: "italic",
                    fontSize: "17px",
                    lineHeight: 1.6,
                    color: "#333",
                    margin: 0,
                  }}
                >
                  "There's something about an owl that hunts fish — completely silent, completely invisible in the dark — that feels like pure wilderness. The thought of these rivers going quiet is one that keeps me up at night."
                </p>
              </div>

              {/* conservation status */}
              <div
                style={{
                  background: "#6d735d",
                  color: "#fff",
                  padding: "24px 28px",
                  marginBottom: "48px",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    color: "rgba(255,255,255,.7)",
                  }}
                >
                  Conservation Status
                </div>
                <p
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: 1.85,
                    margin: 0,
                    color: "rgba(255,255,255,.92)",
                  }}
                >
                  Globally, Pel's Fishing Owl is classified as Least Concern by the IUCN, with a wide but patchy distribution across sub-Saharan Africa. However, in South Africa it is listed as Endangered on the national Red List, with only an estimated 70 to 100 mature individuals remaining — restricted almost entirely to a handful of lowveld rivers and the iSimangaliso Wetland Park. The population is suspected to be slowly declining, and the true extent of the decline is not fully known.
                </p>
              </div>

              {/* why in trouble */}
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "28px",
                  fontWeight: 400,
                  margin: "0 0 32px 0",
                }}
              >
                Why This Species Is In Trouble
              </h2>

              <div style={{ position: "relative", marginBottom: "40px" }}>
                {/* vertical line */}
                <div
                  style={{
                    position: "absolute",
                    left: "3px",
                    top: 0,
                    bottom: 0,
                    width: "1px",
                    background: "#ddd",
                  }}
                />

                {[
                  {
                    title: "Deforestation of River Forests",
                    text: "Pel's Fishing Owls are completely dependent on large, mature trees overhanging clean rivers. As riparian forests are cleared for agriculture and timber, these owls lose not just their perches but their entire world.",
                  },
                  {
                    title: "River Degradation",
                    text: "Agricultural runoff, pesticides, and sedimentation are degrading the rivers these owls hunt in. Declining fish populations — the owl's only food source — directly translate to fewer breeding attempts and higher chick mortality.",
                  },
                  {
                    title: "Hydroelectric Dams",
                    text: "Dams alter river flow patterns, temperature, and sediment dynamics in ways that reshape the fish communities Pel's Fishing Owls depend on. Some dam projects have effectively extirpated the species from entire river systems.",
                  },
                  {
                    title: "Extremely Limited Range",
                    text: "With only 70 to 100 individuals estimated in South Africa, this owl has almost no buffer against catastrophe. A single disease event, a prolonged drought, or the loss of a few key river systems could prove decisive.",
                  },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", marginBottom: "36px" }}>
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background: "#c98d2c",
                        flexShrink: 0,
                        marginTop: "6px",
                        marginRight: "20px",
                        position: "relative",
                        zIndex: 2,
                      }}
                    />
                    <div>
                      <h6
                        style={{
                          fontFamily: "Georgia, 'Times New Roman', serif",
                          fontSize: "15px",
                          fontWeight: 600,
                          margin: "0 0 6px 0",
                        }}
                      >
                        {item.title}
                      </h6>
                      <p
                        style={{
                          fontFamily: "'Helvetica Neue', Arial, sans-serif",
                          fontSize: "13px",
                          lineHeight: 1.85,
                          color: "#666",
                          margin: 0,
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* pull quote */}
              <div
                style={{
                  background: "#6d735d",
                  color: "#fff",
                  padding: "40px 44px",
                  margin: "0 0 48px 0",
                }}
              >
                <div
                  style={{
                    fontSize: "48px",
                    color: "#e0b04b",
                    lineHeight: 1,
                    marginBottom: "8px",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  "
                </div>
                <p
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontStyle: "italic",
                    fontSize: "22px",
                    lineHeight: 1.55,
                    margin: 0,
                  }}
                >
                  Pel's Fishing Owl is an indicator species — where it survives, the river is healthy. Where it disappears, something has gone deeply wrong with the ecosystem.
                </p>
              </div>

              {/* what we're doing */}
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "28px",
                  fontWeight: 400,
                  margin: "0 0 20px 0",
                }}
              >
                We're supporting the following activities
              </h2>

              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "48px" }}>
                {[
                  "Protecting riparian corridor forests along key river systems",
                  "Water quality monitoring at critical owl habitat sites",
                  "Working with local fishing communities on sustainable practices",
                  "Nest site identification and long-term protection programs",
                  "Camera trap networks for population monitoring",
                ].map((item, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#fff",
                      border: "1px solid #e8e5df",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13.5px",
                      color: "#333",
                    }}
                  >
                    <span style={{ color: "#c98d2c", marginRight: "12px", fontSize: "16px" }}>○</span>
                    {item}
                  </div>
                ))}
              </div>

              {/* reasons for hope */}
              <div style={{ background: "#6d735d", padding: "28px 32px", color: "#fff" }}>
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,.7)",
                    marginBottom: "10px",
                  }}
                >
                  Reasons For Hope
                </div>
                <p
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: 1.85,
                    margin: "0 0 20px 0",
                    color: "rgba(255,255,255,.92)",
                  }}
                >
                  Community-based river protection programs are showing results in several river systems. Every nest site we protect matters enormously when the total population is this small.
                </p>
                <img
                  src="/Images/Pelss2.png"
                  alt=""
                  style={{ width: "100%", display: "block" }}
                />
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PelsFishingOwl;